/**
 * NUDIENT: Raden överst på phone-cases efter ett modellbyte på en skalsida
 * där skaltypen saknas för den nya modellen, M-157. Plan:
 * nudient/PLAN-modellbyte-saknas.md punkt c och d.
 *
 * "Thin Case finns inte för iPhone Duo. Här är alla skal för iPhone Duo."
 *
 * - assets/nudient-model-picker.js sparar skälet i sessionStorage,
 *   nudient:model-miss, precis före sidbytet. Adressen är samma som
 *   menylänkens, så ingen ny sida uppstår i sök.
 * - Raden visas bara om posten är högst 30 sekunder gammal och filtrets
 *   värde i adressen är samma som i posten, utan hänsyn till stora och små
 *   bokstäver, eftersom filtrets huvud kan byta skrivsättet,
 *   snippets/nudient-model-filter-head.liquid punkt 2.
 * - Posten tas bort direkt när den har lästs, så att raden visas en gång.
 *   Vid omladdning finns posten inte längre. Elementet står inne i
 *   rutnätet, som Horizon ritar om vid filterbyte och modellbyte, och
 *   försvinner då.
 * - Elementet ritas bara när rutnätet har kort, sections/nudient-collection-grid.liquid.
 *   I tomt läge står texten om att skal saknas ensam.
 * - Byter filtrets huvud adressen, och har därför dolt sidan, läses posten
 *   inte, så att den finns kvar för den nya sidan.
 * - Texten fylls med textContent, så att namnen aldrig blir kod.
 *
 * Värden som inte kommer från butiken eller en token:
 * - nudient:model-miss: nyckeln, samma som i assets/nudient-model-picker.js.
 * - 30000: millisekunder som posten gäller.
 * - [type] och [model]: platserna i texten nudient.filter.type_missing.
 * - filter.p.m.attribute.compatible_models: filtrets parameter, M-013.
 */

const KEY = 'nudient:model-miss';
const PARAM = 'filter.p.m.attribute.compatible_models';
const MAX_AGE = 30000;

class NudientModelMiss extends HTMLElement {
  connectedCallback() {
    /* Filtrets huvud byter adressen och har dolt sidan: posten sparas till
       den nya sidan. */
    if (getComputedStyle(document.documentElement).visibility === 'hidden') return;
    let miss = null;
    try {
      miss = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      sessionStorage.removeItem(KEY);
    } catch {
      return;
    }
    if (!miss || !miss.type || !miss.model || typeof miss.at !== 'number') return;
    if (Date.now() - miss.at > MAX_AGE) return;
    const value = new URL(window.location.href).searchParams.get(PARAM) || '';
    if (value.trim().toLowerCase() !== String(miss.value || '').trim().toLowerCase()) return;
    const text = this.querySelector('.nudient-filter-empty__text');
    const template = this.dataset.text || '';
    if (!text || !template) return;
    text.textContent = template.replaceAll('[type]', miss.type).replaceAll('[model]', miss.model);
    this.hidden = false;
  }
}

if (!customElements.get('nudient-model-miss')) customElements.define('nudient-model-miss', NudientModelMiss);
